module.exports = __webpack_public_path__ + "static/media/signup.bec34c35.svg";